import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGolfBall, FaCheck, FaTimes, FaMapMarkerAlt, FaFlag } from 'react-icons/fa';
import { addCourse } from '../utils/api';
import './AddCourse.css';

const AddCourse = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  // Form state
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [holes, setHoles] = useState(18);
  const [par, setPar] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name) {
      setError('Banans namn måste anges.');
      return;
    }
    
    try {
      setLoading(true);
      const courseData = {
        name,
        location: location || null,
        holes: parseInt(holes) || 18,
        par: par ? parseInt(par) : null
      };
      
      const response = await addCourse(courseData);
      
      if (response.error) {
        setError(response.message);
      } else {
        setSuccess(true);
        setError(null);
        
        // Reset form and redirect after 2 seconds
        setTimeout(() => {
          navigate('/rounds');
        }, 2000);
      }
    } catch (err) {
      setError('Kunde inte lägga till bana. Försök igen.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="container">
      <div className="page-title">
        <FaGolfBall />
        <h1>Lägg till bana</h1>
      </div>
      
      {error && <div className="error">{error}</div>}
      {success && (
        <div className="success">
          <FaCheck /> Banan har lagts till! Omdirigerar...
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="add-course-form card">
        <div className="form-group">
          <label htmlFor="name" className="form-label">
            <FaGolfBall /> Namn *
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-input"
            placeholder="Ange banans namn"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="location" className="form-label">
            <FaMapMarkerAlt /> Plats (valfritt)
          </label>
          <input
            type="text"
            id="location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="form-input"
            placeholder="Ange banans plats/stad"
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="holes" className="form-label">
              <FaFlag /> Antal hål
            </label>
            <input
              type="number"
              id="holes"
              value={holes}
              onChange={(e) => setHoles(e.target.value)}
              className="form-input"
              min="1"
              max="36"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="par" className="form-label">
              <FaFlag /> Par (valfritt)
            </label>
            <input
              type="number"
              id="par"
              value={par}
              onChange={(e) => setPar(e.target.value)}
              className="form-input"
              min="18"
              placeholder="Banans par"
            />
          </div>
        </div>
        
        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate('/rounds')}
            className="btn cancel-btn"
          >
            <FaTimes /> Avbryt
          </button>
          <button 
            type="submit" 
            className="btn submit-btn" 
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="button-spinner"></span> Sparar...
              </>
            ) : (
              <>
                <FaCheck /> Spara bana
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCourse; 